export const STAKING_THRESHOLD = 10000
/** three contract method gasLimit ratio (enter/leave/withdraw : 0.28/0.41/0.31)
 *  2(basic multiplier) * (100/28)
 */
export const GAS_FEE_MULTIPLIER = 2 * (100 / 28)
export const MINIMUM_REMAIN_TT = 1.5
export const MAX_INPUT_AMOUNT = Math.pow(10, 11)
export const MAX_INPUT_FLOATING_POINT = 18
